import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import SearchResetButton from '../../ResetButton';
import './style.scss';

const SearchAllContentResultsEmptyState: React.FC = () => {
  const { t } = useTranslation();

  const classNames = c('SearchAllContent__Results__EmptyState');

  return (
    <div className={classNames}>
      <div>
        <h2 className="asH3">{t('components.search.empty_state.title')}</h2>
        <p>{t('components.search.empty_state.body')}</p>
      </div>
      <SearchResetButton
        buttonText={t('components.search.empty_state.reset')}
      />
    </div>
  );
};

export default SearchAllContentResultsEmptyState;
